export type IconProps = {
  width?: string;
  height?: string;
  color?: string;
};

const AffiliateIcon = ({
  width = "24",
  height = "24",
  color = "#2A2C2E",
}: IconProps) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.6125 11.7337C14.5388 11.7712 15.0712 12.165 15.3975 12.7125C15.5662 12.9975 15.66 13.3762 15.66 13.8075C15.66 14.2387 15.57 14.64 15.3863 14.955C14.97 15.6975 14.0812 16.1287 12.8175 16.1663V17.2087H11.3588V16.1663H9V7.0425H11.3588V6H12.8175V7.0425C14.0812 7.08 14.97 7.51125 15.3863 8.25375C15.57 8.565 15.66 8.95875 15.66 9.40125C15.66 9.84375 15.57 10.2112 15.3975 10.4963C15.0862 11.0437 14.5125 11.4225 13.6125 11.46V11.7337ZM13.4588 9.8025C13.4588 9.5925 13.4212 9.42375 13.3425 9.28125C13.1588 8.9925 12.8213 8.865 12.3263 8.865H11.0625V10.755H12.3263C12.8213 10.755 13.1588 10.6125 13.3425 10.3125C13.4212 10.17 13.4588 10.0125 13.4588 9.8025ZM13.4588 13.4025C13.4588 13.1925 13.4212 13.0388 13.3425 12.8925C13.1588 12.5925 12.8213 12.45 12.3263 12.45H11.0625V14.34H12.3263C12.8213 14.34 13.1588 14.2088 13.3425 13.9238C13.4212 13.7813 13.4588 13.6125 13.4588 13.4025Z"
          fill={color}
        />
      </svg>
    </>
  );
};

export default AffiliateIcon;
